// Vendor Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Error from '../core/error';
import ShellForm from './shell-form';
import Permissions from '../core/permissions';
import Button from '../core/button';
import FormConfirm from '../core/form-confirm';
import Loading from '../core/loading';

// Containers
import FormData from '../../containers/form-data';
import Deletable from '../../containers/deletable';

// Styles
import './edit-shell.scss';
import withForm from '../../containers/with-form';

const formName = 'editShell';

function EditShell({ setFieldValue }) {
  const getDeletableProps = (echostarId) => ({
    recordId: echostarId,
    formName: 'deleteShell',
  });

  const getFormConfirmProps = (
    { deleteCompleted, handleConfirmClick, handleResetClick, resetDelete, status: { error, fetching, response } },
    { values: searchData = {} } = {},
  ) => ({
    completed: deleteCompleted,
    confirmMessage: 'Are you sure you want to delete this shell?',
    confirmLabel: 'Delete',
    error,
    fetching,
    formSubmitReset: resetDelete,
    onComplete: handleResetClick,
    onCancel: resetDelete,
    onConfirm: handleConfirmClick,
    response,
    searchData,
    whitelistKeys: ['title', 'echostarContentType', 'echostarId'],
  });

  const renderDeleteButton = (deletable, { mappedCounts: { DISH, SLING } = {} }) => {
    const {
      handleDeleteClick,
      status: { fetching },
      shouldRenderDeleteButton,
    } = deletable;

    return !fetching && shouldRenderDeleteButton() ? (
            <Permissions accessRequirement="write">
                <div className="edit-shell--buttons">
                    <Button className="edit-shell--button" disabled={!!(DISH || SLING)} onClick={handleDeleteClick}>
                        Delete
                    </Button>
                </div>
            </Permissions>
    ) : null;
  };

  return (
        <Permissions accessRequirement="write" notAuthorizedMessage={true}>
            <FormData formName={formName}>
                {({
                  formData,
                  resetForm,
                  searchFetching,
                  searchValues,
                  searchValues: { echostarContentType, echostarId, roviProgramId, tmsId, sourceId } = {},
                  setFormSubmitted,
                }) => (echostarId && !roviProgramId && !tmsId && !sourceId ? (
                        <Deletable {...getDeletableProps(echostarId)}>
                            {(deletable) => (
                                <div className="edit-shell">
                                    {renderDeleteButton(deletable, searchValues)}
                                    {deletable.shouldRenderConfirm() ? (
                                        <FormConfirm {...getFormConfirmProps(deletable, formData)} />
                                    ) : (
                                        <ShellForm
                                            {...{
                                                className: 'edit-shell',
                                                editing: true,
                                                episodeOnly: echostarContentType === 'SRE',
                                                formData,
                                                formName,
                                                onReset: (submitted, resetValues) =>
                                                    resetForm(submitted, resetValues, true),
                                                searchFetching,
                                                setFieldValue,
                                                setFormSubmitted,
                                            }}
                                        />
                                    )}
                                    <Loading loading={deletable.status.fetching} />
                                </div>
                            )}
                        </Deletable>
                    ) : (
                        <Error error="Record must be a shell in order to edit it." />
                    ))}
            </FormData>
        </Permissions>
  );
}

EditShell.propTypes = {
    setFieldValue: PropTypes.func,
};

export default withForm(EditShell, formName);
